<template>

  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="m-2">

      <b-row>

        <!-- Per Page -->
        <b-col
          cols="8"
          md="3"
          class=" d-none d-md-block d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Registro por pagina</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block ml-50 mr-1"
          />
        </b-col>
        <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <v-select
              v-model="searchBy"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="searchOptions"
              class="invoice-filter-select"
              placeholder="Opcion"
            >
              <template #selected-option="{ label }">
                <span>
                  {{ label }}
                </span>
              </template>
            </v-select>
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1 ml-1"
              placeholder=""
            />
            <b-button
            v-if="isFiltered"
            variant="secondary"
            @click="cleanFilter"
          >Limpiar Busqueda
          </b-button>
            <b-button
            v-if="!isFiltered"
            variant="primary"
            @click="searchCfdi"
          >Buscar
          </b-button>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <div class="d-flex align-items-center justify-content-end mb-1 mb-md-0">
            <v-select
              v-model="statusFilter"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="statusOptions"
              class="invoice-filter-select"
              placeholder="Estatus"
            >
              <template #selected-option="{ label }">
                <span class="text-truncate overflow-hidden">
                  {{ label }}
                </span>
              </template>
            </v-select>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-table
      ref="refInvoiceListTable"
      :items="fetchInvoices"
      responsive
      :fields="tableColumns"
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      empty-text="No matching records found"
      :sort-desc.sync="isSortDirDesc"
      :busy="isBusy"
      class="position-relative">

    <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Cargando...</strong>
        </div>
    </template>

       <template #head(estatus)>
        <feather-icon
          icon="TrendingUpIcon"
          class="mx-auto"
        />
      </template>

      <!-- Column: Id -->
      <template #cell(id)="data">
        <b-link
          :to="{ name: 'apps-invoice-preview', params: { id: data.item.id }}"
          class="font-weight-bold"
        >
          #{{ data.value }}
        </b-link>
      </template>

      <!-- Column: Invoice Status -->
      <template #cell(estatus)="data">
        <b-avatar
          :id="`invoice-row-${data.item.id}`"
          size="32"
          :variant="`light-${resolveInvoiceStatus(data.item.estatus).variant}`"
        >
          <feather-icon
            :icon="resolveInvoiceStatus(data.item.estatus).icon"
          />
        </b-avatar>
        <template v-if="data.item.estatus === 200">
          <b-tooltip
          :target="`invoice-row-${data.item.id}`"
          placement="top"
        >
          <b-badge
            pill
            variant="light-success"
          >
            Vigente
          </b-badge>
        </b-tooltip>
        </template>
        <template v-else>
          <b-tooltip
          :target="`invoice-row-${data.item.id}`"
          placement="top"
        >
          <p class="mb-0">
            Cancelado
          </p>
          <p class="mb-0">
            Fecha de Cancelacion:
          </p>
          <p class="mb-0">{{ data.item.fechaCancelacion }}
          </p>
        </b-tooltip>
        </template>

        
      </template>

      <!-- Column: Client -->
      <template #cell(razonSocialReceptor)="data">
        <b-media vertical-align="center">
          <span class="text-muted">
            {{ data.value }}
          </span>
          <!--<small class="text-muted">{{ data.item.client.companyEmail }}</small> -->
        </b-media>
      </template>

      <!-- Column: Issued Date -->
      <template #cell(fechaEmision)="data">
        <span class="text-nowrap">
          {{ data.item.fechaEmision }}
        </span>
      </template>

      <!-- Column: Balance -->
      <template #cell(importe)="data">
        <template>
          <span class="font-weight-bold d-block text-nowrap">
            {{ data.value }}
          </span>
        </template>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">

        <div class="text-nowrap">
          <feather-icon
            :id="`invoice-row-${data.item.id}-send-icon`"
            icon="SendIcon"
            class="cursor-pointer"
            size="16"
          />
          <b-tooltip
            title="Send Invoice"
            class="cursor-pointer"
            :target="`invoice-row-${data.item.id}-send-icon`"
          />

          <feather-icon
            :id="`invoice-row-${data.item.id}-preview-icon`"
            icon="EyeIcon"
            size="16"
            class="mx-1"
            @click="$router.push({ name: 'apps-invoice-preview', params: { id: data.item.id }})"
          />
          <b-tooltip
            title="Preview Invoice"
            :target="`invoice-row-${data.item.id}-preview-icon`"
          />

          <!-- Dropdown -->
          <b-dropdown
            variant="link"
            toggle-class="p-0"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item>
              <feather-icon icon="DownloadIcon" />
              <span class="align-middle ml-50">Download</span>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'apps-invoice-edit', params: { id: data.item.id } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
            <b-dropdown-item>
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
            <b-dropdown-item>
              <feather-icon icon="CopyIcon" />
              <span class="align-middle ml-50">Duplicate</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>

    </b-table>
    <div class="mx-2 mb-2">
      <b-row>

        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalInvoices"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,BSpinner
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import vSelect from 'vue-select'
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import useCfdiList from './useCfdiList'


//import invoiceStoreModule from '../invoiceStoreModule'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BSpinner,
    vSelect,
  },
  setup() {
   // const INVOICE_APP_STORE_MODULE_NAME = 'app-invoice'

    // Register module
   /* if (!store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.registerModule(INVOICE_APP_STORE_MODULE_NAME, invoiceStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.unregisterModule(INVOICE_APP_STORE_MODULE_NAME)
    })*/

    const statusOptions = [
      'Vigentes',
      'Cancelados'
    ]
    const searchOptions=[
      'UUID',
      'RFC Emisor',
      'RFC Receptor'
    ]
    const {
      fetchInvoices,
      tableColumns,
      perPage,
      currentPage,
      totalInvoices,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refInvoiceListTable,

      statusFilter,
      isBusy,
      searchBy,
      searchCfdi,
      isFiltered,
      cleanFilter,

      refetchData,
      resolveInvoiceStatus,
      resolveInvoiceStatusVariantAndIcon,
      resolveClientAvatarVariant,
    } = useCfdiList()

    return {
      fetchInvoices,
      tableColumns,
      perPage,
      currentPage,
      totalInvoices,
      dataMeta,
      perPageOptions,
      
      searchQuery,
      sortBy,
      searchBy,

      isSortDirDesc,
      refInvoiceListTable,

      statusFilter,

      refetchData,

      searchOptions,
      statusOptions,
      isBusy,
      searchCfdi,
      isFiltered,
      cleanFilter,

      avatarText,
      resolveInvoiceStatus,
      resolveInvoiceStatusVariantAndIcon,
      resolveClientAvatarVariant,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
